<h3 class="d-block d-lg-none d-md-none d-sm-none community">Join the community</h3>
<div class="raised-wrapper">
  <!-- <div class="inline-div">
    <h3>₹{{ variablesService.RAISED }}</h3>
    <span>Raised</span>
  </div> -->
  <div class="inline-div">
    <h3>{{ variablesService.PLATFORMFEE }}</h3>
    <span>Platform Fee*</span>
  </div>
  <div class="inline-div">
    <h3>{{ variablesService.DONORS }}</h3>
    <span>Contributors</span>
  </div>
  <div class="inline-div">
    <h3>{{ variablesService.FUNDRAISERS }}</h3>
    <span>Fundraisers</span>
  </div>
</div>
<div class="ketto-platform-fee">
  Ketto’s <strong> <span class="fs-2rem"> 0</span>% Platform fees*</strong> ensures maximum funds for you
</div>
